import apiFetch from '../../apiFetch'

export default function (idControlMorfologico) {
  return apiFetch({endPoint: `ControlMorfologico/getControlMorfologico?idControlMorfologico=${idControlMorfologico}`, method: 'GET', body: null})
}
